import { PolicyEntryOperation } from '../../dtos/policy-entry-operation';
import { DeviceVaultOperation } from './device-vault-operation';
import { DeviceVaultValidationContext } from './device-vault-validation-context';
export class DeviceVault {
    constructor(entries, groupVault, groupPolicyVault) {
        this.entries = [];
        this.entries = entries.sort((a, b) => a.entryId - b.entryId);
        this.groupVault = groupVault;
        this.groupPolicyVault = groupPolicyVault;
    }
    get effectiveGroups() {
        const effectiveGroups = this.groupVault.effectiveEntries;
        const groupEntries = this.entries.filter(entry => entry.operation === DeviceVaultOperation.AddGroup || entry.operation === DeviceVaultOperation.RemoveGroup);
        const grouppedGroupEntries = groupEntries
            .reduce((dict, entry) => {
            dict[entry.groupId] = entry;
            return dict;
        }, {});
        const deviceEffectiveGroups = Object.values(grouppedGroupEntries).filter(e => e.operation !== DeviceVaultOperation.RemoveGroup);
        return deviceEffectiveGroups.filter(deviceEntry => effectiveGroups.find(groupEntry => groupEntry.groupId === deviceEntry.groupId));
    }
    effectivePolicies(policyType) {
        const replaceEntries = this.groupPolicyVault.effectiveReplaceEntriesAt();
        let result = [];
        let devicePolicyEntries = this.entries
            .filter(e => e.operation === DeviceVaultOperation.AddPolicy || e.operation === DeviceVaultOperation.RemovePolicy);
        if (policyType !== null) {
            devicePolicyEntries = devicePolicyEntries.filter(e => e.policyType === policyType || (e.operation === DeviceVaultOperation.RemovePolicy));
        }
        const mapOperationFromDeviceVaultOperation = (operation) => {
            switch (operation) {
                case DeviceVaultOperation.AddPolicy:
                    return PolicyEntryOperation.AddPolicy;
                case DeviceVaultOperation.RemovePolicy:
                    return PolicyEntryOperation.RemovePolicy;
                default:
                    throw new Error(`${operation} is not supported when mapping to PolicyEntryOperation`);
            }
        };
        const devicePolicyEntriesWithReplace = devicePolicyEntries
            .map(e => ({
            addedAt: e.addedAt,
            operation: mapOperationFromDeviceVaultOperation(e.operation),
            policyId: e.policyId,
            replacedPolicyId: null,
            policyHash: e.policyHash,
            policyType: e.policyType
        }))
            .concat(replaceEntries.map(e => ({
            addedAt: e.addedAt,
            operation: PolicyEntryOperation.ReplacePolicy,
            policyId: e.policyId,
            replacedPolicyId: e.replacedPolicyId,
            policyHash: e.policyHash,
            policyType: e.policyType
        })))
            .sort((a, b) => a.addedAt.getTime() - b.addedAt.getTime());
        for (const entry of devicePolicyEntriesWithReplace) {
            switch (entry.operation) {
                case PolicyEntryOperation.AddPolicy:
                    result.push({ groupId: null, policyId: entry.policyId, policyHash: entry.policyHash, policyType: entry.policyType });
                    break;
                case PolicyEntryOperation.ReplacePolicy:
                    result = result.map(resultEntry => {
                        if (resultEntry.policyId !== entry.replacedPolicyId) {
                            return resultEntry;
                        }
                        return { policyId: entry.policyId, policyHash: entry.policyHash, groupId: null, policyType: resultEntry.policyType };
                    });
                    break;
                case PolicyEntryOperation.RemovePolicy:
                    result = result.filter(e => e.policyId !== entry.policyId);
                    break;
            }
        }
        return result;
    }
    static async Create(entries, keyVault, groupVault, groupPolicyVault, supressValidation = false) {
        const vault = new DeviceVault(entries, groupVault, groupPolicyVault);
        if (!supressValidation || entries.length > 0) {
            const validationContext = new DeviceVaultValidationContext(entries, keyVault, groupVault, groupPolicyVault);
            await validationContext.validateAll();
        }
        return vault;
    }
    getLastEntry() {
        return this.entries.length > 0 ? this.entries[this.entries.length - 1] : null;
    }
}
